import { DocumentData } from "../types/DocumentData";
import { ADJUSTMENT_SUPPLEMENT_SUBTYPE, SURVEY_ELEMENT_SLOT_FINAL, SURVEY_ELEMENT_TYPE_REPORT } from "./Constants";

export function hasAvailableFile(document?: DocumentData) {
    if (!document) {
        return false;
    }

    return !!document.value?.url;
}

export const filterSupplements = (
    filter: boolean | undefined,
    document: DocumentData
) => {
    // 4 is element type of Report
    const isSupplement =
        document.value.elementType === SURVEY_ELEMENT_TYPE_REPORT &&
        document.value.slot === SURVEY_ELEMENT_SLOT_FINAL &&
        document.value.availableForCustomer;

    if (filter) {
        return !isSupplement;
    }

    return isSupplement;
};

export const hasAdjustedGradingSupplement = (documents: DocumentData[]) => {
    return documents?.some((document) => {
        return (
            document.value.elementType === SURVEY_ELEMENT_TYPE_REPORT &&
            document.value.slot === SURVEY_ELEMENT_SLOT_FINAL &&
            document.value.availableForCustomer &&
            document.value.subTypes.includes(ADJUSTMENT_SUPPLEMENT_SUBTYPE)
        );
    });
}